import React from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import '../css/Zahid.css'; // Ensure the correct path to your CSS file


const cardData = [
    {
        title: 'Title: "“RoboQuin”: A Mannequin Robot with Natural Humanoid Movements',
        contentSections: [
            {
                title: "Reference:",
                text: "M. Shidujaman, S. Zhang, R. Elder, and H. Mi, “Social Robots’ Literature Review,” in 2018 27th IEEE International Symposium on Robot and Human Interactive Communication (RO-MAN), 2018, pp. C7.",



            },
          

            {
                title: "Introduction",
                text: "In this paper, the authors introduce RoboQuin, a unique social robot designed to enhance human-robot interaction. They highlight the need for more naturalistic behavior in social robots and explain how RoboQuin's design aims to address this challenge."
            },
            
            {
                title: "Design Method",
                text: "A. Concept: The authors discuss the concept behind RoboQuin, which involves mimicking human body proportions and movements, inspired by mannequin sculpture.\nB. Body Shape and Structure: They describe how RoboQuin's body shape and joint structure closely resemble human anatomy, with a focus on head, torso, and arm proportions.\nC. Natural Body Movement Representation: The paper explains how they achieved natural movements in RoboQuin using animation techniques, creating a mapping between action units and joint movements."
            },
            
            {
                title: "Implementation",
                text: "A. Hardware System: This section discusses the hardware components of RoboQuin, including servomotors and the control system.\nB. Control Layer: It describes how RoboQuin's joints are controlled through a unifying module, and voice commands can also be used for control.\nC. Intelligent Layer Controller: The software control module, involving voice control and body movement, is discussed here.\nD. Battery Life: Details about RoboQuin's battery life and charging capabilities are presented."
            },
            
            {
                title: "Expressive Action Examples",
                text: "The authors showcase various expressive actions performed by RoboQuin, including greeting interactions and expressive gestures that improve human-robot communication."
            },
            
            {
                title: "Conclusion and Future Work",
                text: "The paper concludes by highlighting RoboQuin's significance in enhancing humanoid robot design. Future research areas include developing more interactive functionalities and natural responsive behavior to improve human-robot interactions."
            },
            

        ],
    },


// 2nd paper title
    

{
    title: 'Title: "Towards the Design of a Robot for Supporting Children’s Attention During Long Distance Learning',
    contentSections: [
        {
            title: "Reference:",
            text: "M. Shidujaman, D. Arroyo, Y. Guo, M. Yu, and R. Fernandes, “Social Robotics,” in Social Robotics, 1st ed., Springer International Publishing, Nov. 2020, pp. 1-14, doi: 10.1007/978-3-030-62056-1_28.",
        },
      
        {
            title: "Introduction",
            text: "This paper discusses the development of a robot designed to assist children in maintaining their attention during online learning. With the rise of remote education, the lack of physical interaction between students, teachers, and peers can lead to issues like decreased attention and motivation. The paper outlines the design process for a companion robot aimed at enhancing children's awareness and attention during online classes."
        },
        
        {
            title: "Background and Related Work",
            text: "The paper explores the challenges of remote education and the potential of robots in education."
        },
        
        {
            title: "Methodology",
            text: "The authors conducted an online survey to understand students' experiences with online learning and their preferences for robot companions."
        },
        
        {
            title: "Results and Design Guidelines",
            text: "The survey showed that most participants desired a companion robot during online classes, preferring a physical robot with a human-like appearance. The paper establishes design guidelines based on the survey results."
        },
        
        {
            title: "Robot Development",
            text: "The authors designed a 3D model of the robot, primarily focusing on a human-like appearance with an enlarged head to aid visibility. The robot's attention states and hardware components are outlined."
        },
        
        {
            title: "Technical Details",
            text: "The hardware components include a Raspberry Pi Zero W as the main controller, a microphone, servomotors for head movement, a small screen, a camera, and speakers. The software uses a state machine to monitor the teacher's tone of voice and speech patterns, triggering expressive behaviors accordingly."
        },
        
        {
            title: "Conclusion",
            text: "The paper presents the design process for a companion robot to support children during online learning, emphasizing the importance of maintaining children's attention and motivation. Further work will explore additional robot behaviors and features."
        },
        
        {
            title: "Key Takeaways",
            text: "The paper addresses the challenges of maintaining children's attention and motivation during online learning. A companion robot with a human-like appearance is proposed to support students during online classes. The robot's hardware includes a Raspberry Pi controller, microphone, servomotors, screen, camera, and speakers. The software uses a state machine to monitor the teacher's speech and trigger expressive behaviors to maintain student attention. Design guidelines are established based on survey results, highlighting the preference for physical robots with human-like appearances."
        },
        


    ],
},


    // Add data for more cards as needed
];

const Sani = () => {
    return (
        <div className="l-r-main">
        <div className="litarater-review-div">
          <h1>Literature Review</h1>
        </div>
        <Row xs={1} md={2} className="g-4">
          {cardData.map((card, cardIdx) => (
            <Col key={cardIdx} className={cardIdx === cardData.length - 1 ? "last-card" : ""}>
              <div className="card-container">
                <Card className="user-custom-card">
                  <Card.Body>
                    <Card.Title>{card.title}</Card.Title>
                    {card.contentSections.map((section, sectionIdx) => (
                      <div key={sectionIdx}>
                        <h6>{section.title}</h6>
                        <p>{section.text}</p>
                      </div>
                    ))}
                  </Card.Body>
                </Card>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    );
  }
export default Sani;
